const IP = process.env.NODE_ENV === 'production' ? 'https://nomu.strategy-offsite-meeting.com/api' : 'https://nomu.strategy-offsite-meeting.com/api';
// const IP = 'https://nomu.strategy-offsite-meeting.com/api';


export default IP;
